export type ISkillState = {
    id: string;
    name: string;
}

export enum ISkillActionTypes {
    FETCH_SKILLS_LIST_REQUEST = 'FETCH_SKILLS_LIST_REQUEST',
    FETCH_SKILLS_LIST_SUCCESS = 'FETCH_SKILLS_LIST_SUCCESS',
    FETCH_SKILLS_LIST_FAILURE = 'FETCH_SKILLS_LIST_FAILURE',

}

export type ISKILLSActionCreator = {
    type: string;
    payload: ISkillState;
};
